// Auth.jsx
import React from "react";
import SignInForm from "../components/LoginForm/SignInForm";

const SignIn = () => {
  return (
    <div className="w-full h-screen overflow-hidden  bg-white p-6">
      <SignInForm />
    </div>
  );
};

export default SignIn;
